import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/hr-by-industry")({
  component: () => <Outlet />,
});
